import React from 'react'
import { NavLink as Link } from 'react-router-dom'

import { AiFillHome, AiOutlinePlusCircle } from 'react-icons/ai'
import { BiSearch, BiTimeFive } from 'react-icons/bi'
import { MdFavoriteBorder, MdPersonOutline } from 'react-icons/md'
import { IoAlbumsOutline } from 'react-icons/io5'
import { RiCompassDiscoverLine } from 'react-icons/ri'

import { useSpotify } from '../../hoc/context/SpotifyContextContainer'
import { GetPlayer } from '../../hoc/Layout/Layout'


import CreateListModal from './CreateListModal'

const NavBar = ({playlists}) => {
    const { setModal } = GetPlayer()
    const { user, accessToken } = useSpotify()

    return (
        <div className="navbar">
            <div className="navbar__brand">
                <h2 className="navbar__name">
                    CHILLLISTS
                </h2>
            </div>
            <ul className="navbar__list">
                <Link className="navbar__link" to="/">
                    <AiFillHome className="navbar__icon" />
                    Home
                </Link>
                <Link to="/discover" className="navbar__link">
                <RiCompassDiscoverLine className="navbar__icon" />
                    Discover
                </Link>
            </ul>
            {/* <ul className="navbar__library">
                <h3>Your Library</h3>
                <Link to="/" className="navbar__link">
                <BiTimeFive className="navbar__icon" />
                    Recently Played
                </Link>
                <Link to="/" className="navbar__link">
                <MdFavoriteBorder className="navbar__icon" />
                    Favorite Songs
                </Link>
                <Link to="/" className="navbar__link">
                <MdPersonOutline className="navbar__icon" />
                    Artists
                </Link>
                <Link to="/" className="navbar__link">
                <IoAlbumsOutline className="navbar__icon" />
                    Albums
                </Link>
            </ul> */}
            <ul className="navbar__playlists">
                <h3>Your Playlists</h3>

               <div className="scroller"> {
                    playlists.map((playlist, i) => (
                        <Link key={i} to={`/playlist/${playlist.id}`} className="navbar__link">
                            {playlist.name}
                        </Link>
                    ))
                }
                </div>
                {/* <button className="navbar__button">
                    Add New Playlist
                </button> */}
            </ul>
            <button className="create-playlist" onClick={()=>setModal(<CreateListModal setModal={setModal} accessToken={accessToken} user={user} />)}><AiOutlinePlusCircle />Add a new playlist</button>
        </div>
    );
};

export default NavBar;